import { createContext, type ReactNode, useContext, useMemo, useState } from "react"

type DemoContextValue = {
  demo: boolean
  setDemo: (value: boolean) => void
  toggleDemo: () => void
}

const DemoContext = createContext<DemoContextValue | undefined>(undefined)

export function DemoProvider({ children }: { children: ReactNode }) {
  const [demo, setDemo] = useState(() => {
    if (typeof window === "undefined") return false
    return window.localStorage.getItem("demon-app.demo") === "true"
  })

  const value = useMemo<DemoContextValue>(
    () => ({
      demo,
      setDemo: (next) => {
        setDemo(next)
        if (typeof window !== "undefined") {
          window.localStorage.setItem("demon-app.demo", String(next))
        }
      },
      toggleDemo: () => {
        setDemo((prev) => {
          const next = !prev
          if (typeof window !== "undefined") {
            window.localStorage.setItem("demon-app.demo", String(next))
          }
          return next
        })
      },
    }),
    [demo],
  )

  return <DemoContext.Provider value={value}>{children}</DemoContext.Provider>
}

export function useDemoMode() {
  const ctx = useContext(DemoContext)
  if (!ctx) {
    throw new Error("useDemoMode must be used within DemoProvider")
  }
  return ctx
}
